module.exports = __webpack_public_path__ + "fonts/Inter-900-vietnamese82.5fc7f74.woff2";